import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";

const CheckoutBuyerSection = ({
  buyerClientLoading,
  buyerClientError,
  buyerClientInfo,
  buyerContactsLoading,
  buyerContactsError,
  buyerContactOptions,
  selectedBuyerContactId,
  onBuyerContactChange,
  buyerFields,
  buyerForm,
  buyerTouched,
  buyerErrors,
  onBuyerFieldChange,
  onBuyerFieldBlur,
  termsAccepted,
  onTermsChange,
  marketingAccepted,
  onMarketingChange,
}) => (
  <Card className="getnet-card-section">
    <h2>Información del Cliente</h2>
    {buyerClientLoading ? (
      <small className="getnet-map-help">
        Cargando información del cliente...
      </small>
    ) : null}
    {/* {buyerClientError ? (
      <small className="getnet-error-message">{buyerClientError}</small>
    ) : null} */}
    <div className="getnet-form-grid mb-4">
      <div className="flex align-items-center gap-2">
        <h5 className="font-semibold">
          Razón Social: {buyerClientInfo.nombre || "Sin nombre disponible"}
        </h5>
      </div>
      <div className="getnet-field">
        <div className="flex align-items-center gap-2">
          <h5 className="font-semibold">
            RUT: {buyerClientInfo.rut || "-"}{" "}
            <i
              className="pi pi-info-circle text-primary text-sm cursor-pointer"
              data-pr-tooltip="Solo se realiza entrega contra facturas"
            ></i>
          </h5>
        </div>
      </div>
      <div className="getnet-field">
        <div className="flex align-items-center gap-2">
          <h5 className="font-semibold">
            Código: {buyerClientInfo.codigo || "-"}
          </h5>
        </div>
      </div>
    </div>

    <h2 style={{ borderTop: "1px solid var(--surface-border)", paddingTop: "1rem", }}>
      Datos de contacto
    </h2>
    {buyerContactsLoading ? (
      <small className="getnet-map-help">Cargando contactos guardados...</small>
    ) : null}
    {!buyerContactsLoading && buyerContactOptions.length ? (
      <div className="getnet-field full-width mb-3">
        <Dropdown
          id="getnet-buyer-contact"
          value={selectedBuyerContactId}
          options={buyerContactOptions}
          onChange={onBuyerContactChange}
          placeholder="Selecciona un contacto guardado"
          showClear
          className="getnet-contact-dropdown"
        />
      </div>
    ) : null}
    {/* {buyerContactsError ? (
      <small className="getnet-error-message">{buyerContactsError}</small>
    ) : null} */}
    {!buyerContactsLoading && !buyerContactsError && !buyerContactOptions.length ? (
      <small className="getnet-map-help">
        No hay contactos guardados para este cliente. Se creará uno con los
        datos ingresados.
      </small>
    ) : null}

    <div className="getnet-form-grid">
      {buyerFields.map((field) => {
        const fieldId = `getnet-${field.label
          .toLowerCase()
          .replace(/\s+/g, "-")}`;
        const hasError = buyerTouched[field.label] && buyerErrors[field.label];
        return (
          <div key={field.label} className="getnet-field">

            <div className="flex align-items-center gap-2">
              <label htmlFor={fieldId}>{field.label}</label>
              {hasError ? (
                <small className="getnet-error-message">
                  ({buyerErrors[field.label]})
                </small>
              ) : null}
            </div>
            <InputText
              id={fieldId}
              value={buyerForm[field.label] ?? field.value}
              className={`p-inputtext-sm getnet-input-shell ${ hasError ? "p-invalid" : "" }`.trim()}
              type={
                field.label === "Correo"
                  ? "email"
                  : field.label === "Teléfono"
                  ? "tel"
                  : "text"
              }
              onChange={(event) => onBuyerFieldChange(field.label, event.target.value)}
              onBlur={() => onBuyerFieldBlur(field.label)}
              autocomplete="off"
            />
         
          </div>
        );
      })}
    </div>

    <div className="mt-4 mb-3">
      <div className="flex align-items-center gap-2">
        <Checkbox
          inputId="terms-acceptance"
          checked={Boolean(termsAccepted)}
          onChange={(e) => onTermsChange?.(e.checked)}
        />
        <label htmlFor="terms-acceptance" className="text-sm cursor-pointer">
          He leído y acepto los{" "}
          <a
            href="/info/Terminos-y-condiciones"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline"
            onClick={(e) => e.stopPropagation()}
          >
            términos y condiciones
          </a>
        </label>
      </div>
      <div className="flex align-items-center gap-2 mt-3">
        <Checkbox
          inputId="marketing-acceptance"
          checked={Boolean(marketingAccepted)}
          onChange={(e) => onMarketingChange?.(e.checked)}
        />
        <label htmlFor="marketing-acceptance" className="text-sm cursor-pointer">
          Acepto recibir información y promociones de marketing
        </label>
      </div>
    </div>

    <Tooltip target=".pi-info-circle" position="top" />
  </Card>
);

export default CheckoutBuyerSection;
